export default __webpack_public_path__ + "static/media/Img212.b7d27f72.jpg";